module.exports = __webpack_public_path__ + "static/media/undraw_under_construction_46pa.459f7fa3.png";